import {SpAlert} from "../../../components/sp-alert/sp-alert.model";

export class Controller {

    /** @ngInject */
    constructor($state, Alert, ResetPasswordVerifyService) {
        this.$state = $state;
        this.Alert = Alert;
        this.ResetPasswordVerifyService = ResetPasswordVerifyService;
    }

    $onInit() {
        this.newpassword = '';
        this.newpasswordAgain = '';
        this.successReset = false;
        this.autoRedirect=this.$state.params.autoRedirect;
    }

    save() {
        this.ResetPasswordVerifyService.resetPassword(this.$state.params.appKey,this.$state.params.rkey,this.newpassword)
            .then(() => this.newpassword = this.newpasswordAgain = '')
            .then(() => this.successReset=true)
    }
}


// WEBPACK FOOTER //
// ./src/portal/states/public/reset-password-verify/reset-password-verify.controller.js